import { render, staticRenderFns } from "./MemberAreaModules.vue?vue&type=template&id=74216bd8&scoped=true&"
import script from "./MemberAreaModules.vue?vue&type=script&lang=js&"
export * from "./MemberAreaModules.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaModules.vue?vue&type=style&index=0&id=74216bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74216bd8",
  null
  
)

export default component.exports